<script>
// Ref
// http://vue-chartjs.org/#/home
// http://www.chartjs.org/docs/latest/
import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>
